import { activityHistoryFiltersSlice } from "../../slice";

export const { setCustomFilterAllValues } = activityHistoryFiltersSlice.actions;
